import Vue from 'vue'
import Router from 'vue-router'
//Rotas abertas ao público
import Login from './views/Login.vue'

//Rotas para ambiente administrativo
import DashboradAdmin from './views/admin/Dashboard'
import AvisosAdmin from './views/admin/views/Avisos'
import Parceiros from './views/admin/views/Parceiros'
import Notificacoes from './views/admin/views/Notificacoes'
import NotificacoesTurma from './views/admin/views/NotificacoesTurma'
import Foruns from './views/admin/views/Foruns'
import Manutencao from "./views/admin/views/Manutencao";

//Rotas para ambiente do aluno
// import DashboardAluno from './views/aluno/Dashboard'
import ProgramacaoAcademica from './views/aluno/views/ProgramacaoAcademica'
import MeusCursos from './views/aluno/views/MeusCursos'
import DetalhesCursos from './views/aluno/views/DetalhesCurso'

//Rotas para todos
import perfilUsuario from './views/Perfil'
import ConfirmarCadastro from './views/ConfirmarCadastro'
import Faleconoscos from "./views/admin/views/Faleconoscos";
import AlunoInfo from "./views/AlunoInformacoes"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    //Rotas administrativo ------------------------------------------
    {
      path: '/admin',
      name: 'dashAdmin',
      component: DashboradAdmin
    },
    {
      path: '/admin/avisos',
      name: 'avisosAdmin',
      component: AvisosAdmin
    },
    {
      path: '/admin/parceiros',
      name: 'parceirosAdmin',
      component: Parceiros
    },
    {
      path: '/admin/notificacoes',
      name: 'notificacoesAdmin',
      component: Notificacoes
    },
    {
      path: '/admin/notificacoesturma',
      name: 'notificacoesturmaAdmin',
      component: NotificacoesTurma
    },
    {
      path: '/admin/foruns',
      name: 'forunsAdmin',
      component: Foruns
    },
    {
      path: '/admin/faleconoscos',
      name: 'faleconoscosAdmin',
      component: Faleconoscos
    },
    {
      path: '/admin/manutencao',
      name: 'ManutencaoAdmin',
      component: Manutencao
    },


    //Rotas aluno ---------------------------------------------------
    {
      path: '/aluno',
      name: 'dashAluno',
      component: ProgramacaoAcademica //DashboardAluno
    },
    {
      path: '/aluno/programacao_academica',
      name: 'programacaoAluno',
      component: ProgramacaoAcademica
    },
    {
      path: '/aluno/programacao_academica/*',
      name: 'detalheAcademicaAluno',
      component: DetalhesCursos
    },
    {
      path: '/aluno/meus_cursos',
      name: 'detalheCursosAluno',
      component: MeusCursos
    },
    {
      path: '/aluno/meus_cursos/*',
      name: 'detalheCursosAlunoId',
      component: DetalhesCursos
    },
    {
      path: '/aluno/faleconoscos',
      name: 'faleconoscosAluno',
      component: Faleconoscos
    },
    //Rotas para todos --------------------------------------------------
    {
      path: '/perfil',
      name: 'perfilUsuario',
      component: perfilUsuario
    },
    {
      path: '/confirmar_cadastro/*',
      name: 'ConfirmarCadastro',
      component: ConfirmarCadastro
    },
    {
      path: '/aluno/*',
      name: 'AlunoInfo',
      component: AlunoInfo
    },
    {
      path: '/manutencao',
      name: 'ManutencaoPublico',
      component: Manutencao
    },
  ]
})
